<template>
    <div class="progress-line-container w-100">
        <div class="main-indicator">
            <slot name="main-specifier" v-if="showMainSpecifier">

            </slot>
        </div>
        <div class="d-flex flex-column align-items-start gap-1 justify-content-between w-100">
            <slot name="title" v-if="showTitle">
                
            </slot>
            <div class="d-flex align-items-center gap-1 w-100">
                <slot name="inner-left-info">
    
                </slot>
                <div class="progress-line-wrapper w-100 d-flex align-items-center justify-content-between w-100" :style="[{'--progressLineBackColor': progressLineBackColor}, {'--progressLineHeight': progressLineHeight}, {'--progressLineBorderRadius': progressLineBorderRadius}]">
                    <div class="progress-line-inner-info d-flex align-items-center justify-content-end w-100">
                        <slot name="inner-right-info" v-if="showRightInfo">
                            
                        </slot>
                    </div>
                    <div class="progress-fill-line d-flex align-items-center justify-content-start" :style="[{'--commonBackgroundColor': commonBackgroundColor}, {'--progressLineFillLevel': progressLineFillLevel}]">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {

        }
    },
    props: {
        showTitle: {
            type: Boolean,
            default: true,
        },
        showRightInfo: {
            type: Boolean,
            default: true,
        },
        showMainSpecifier: {
            type: Boolean,
            default: true,
        },
        progressLineBorderRadius: {
            type: String,
            default: "15px",
        },
        progressLineFillLevel: {
            type: String,
            default: "0%",
        },
        progressLineBackColor: {
            type: String,
            default: "#F5F7FA",
        },
        progressLineHeight: {
            type: String,
            default: "35px",
        },
        commonBackgroundColor: {
            type: String,
            default: "green",
        },
    },
}
</script>
<style scoped>
.progress-line-container{
    display: grid;
    grid-template-columns: min-content auto;
    grid-template-rows: 1fr;
    gap: 1em;
}
.progress-line-wrapper{
    height: var(--progressLineHeight);
    position: relative;
    background-color: var(--progressLineBackColor);
    border-radius: var(--progressLineBorderRadius);
    overflow: hidden;
    z-index: 1;
    padding-inline: 12px;
}
.progress-line-wrapper .progress-fill-line{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background-color: var(--commonBackgroundColor);
    width: var(--progressLineFillLevel);
    border-radius: var(--progressLineBorderRadius);
    z-index: -1;
    transition: all 0.3s ease-out;
}
</style>